import { render, staticRenderFns } from "./TabAvaliacaoAtendimento.vue?vue&type=template&id=34c85653&scoped=true"
import script from "./TabAvaliacaoAtendimento.vue?vue&type=script&lang=js"
export * from "./TabAvaliacaoAtendimento.vue?vue&type=script&lang=js"
import style0 from "./TabAvaliacaoAtendimento.vue?vue&type=style&index=0&id=34c85653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c85653",
  null
  
)

export default component.exports